import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import PropTypes from 'prop-types';
import NotificationTasksCard from '../../NotificationTaskCard';
import NotificationTaskDocumentBox from './NotificationTaskDocumentBox';
import CTextAreaSimple from '../../../../components/Common/CTextAreaSimple';
import MessageBox from '../../../../components/Common/Message/MessageBox';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import { __MessageTypes, enum__NOTIFICATION_CLASS, enum__NOTIFICATION_INBOX_TYPE } from '../../../../common/Dictionaries';
import { isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../common/Helpers';
import { addAchievementComment, addValidationComment, setNotificationCompleted } from '../../../../services/sNotificationAlerts/notificationAlerts.service';
import { useGetNotificationDetails } from '../../../../hooks/services/NotificationTask/useOfNotificacionTask';
import { action_setNotificacionTaskList, action_setNotificacionTaskListFiltred, action_setNotificacionTaskMenuItems } from '../../../../reducers/actions/NotificationTasks/actions';
import { action_updateAlertList } from '../../../../reducers/actions/SITE/actions';
import { action_updateEdPPrepareForceGetHeader } from '../../../../reducers/actions/PAY/edpPrepareActions';
import moment from 'moment';
import DOMPurify from 'dompurify';

const SidePanelAchieveValidateNotification = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    
    const { 
        inputParam_IsPanelOpen = null, 
        inputParam_NotificationTask = null,     
        inputParam_SetterIsPanelOpen = null,     
        inputParam_NeedUpdateNotificationPageList = true,  
        inputParam_SkipActionListUpdate = false,
        inputParam_ExternalEventAfterSave = null
    } = props;
    
    const { 
        _notificationTaskDataList: notificationTaskDataList,
        _notificationTaskDataListFiltred: notificationTaskDataListFiltred,
        _notificationTaskMenuData: notificationTaskMenuData,
    } = useSelector((state) => state.notificationTaskState);

    const {
        _alertList: alertList,
    } = useSelector((state) => state.notificationAlertState);

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [objAchieveValidation, setObjAchieveValidation] = useState(null);
    const [achievemtComment, setAchievemtComment] = useState("");
    const [validationComment, setValidationComment] = useState("");
    const [isValidForm, setIsValidForm] = useState(true);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    useGetNotificationDetails(inputParam_NotificationTask.id, objAchieveValidation, setObjAchieveValidation, setAchievemtComment, setValidationComment);

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    // Distingue el 400 de validación (FluentValidation, ej. SafeText) que devuelve
    // { errors: { comentario: [...] } } del resto de errores, para no mostrar
    // siempre el mensaje genérico cuando el comentario tiene caracteres no permitidos.
    const getSaveCommentErrorMessage = (error) => {
        const validationErrors = error && error.response && error.response.status === 400 ? (error.response.data && error.response.data.errors) : null;
        return !isNullUndefined(validationErrors) ? t('data-lang-msg-commentinvalidcharacters') : t('data-lang-msg-operationerror');
    };

    const handleSaveButtonClick = (achieve) => {
        let saveFunction = null;
        let commentToSave = null;
        let isValidForm = true;

        switch (inputParam_NotificationTask.notificationClassId) {
            case enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE:
                saveFunction = addAchievementComment;
                commentToSave = achievemtComment;
                if (objAchieveValidation.item_cumplimiento.requiereDocumento === true && (objAchieveValidation.item_cumplimiento.documentoCumplimientoId === null || isNullUndefinedOrEmpty(commentToSave))) {
                    isValidForm = false;
                }
                else {
                    isValidForm = true;
                }
                break;
            case enum__NOTIFICATION_CLASS.CO_TO_VALIDATE:
                saveFunction = addValidationComment;
                commentToSave = validationComment;
                if (isNullUndefinedOrEmpty(commentToSave)) {
                    isValidForm = false;
                }
                else {
                    isValidForm = true;
                }
                break;
            default:
                break;
        }

        setIsValidForm(isValidForm);

        if (isValidForm === true) {
            saveFunction(objAchieveValidation.item_cumplimiento.id, commentToSave).then((response) => {
                if (response.data.succeeded) {
                    switch (inputParam_NotificationTask.notificationClassId) {
                        case enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE:
                            setObjAchieveValidation(prev => ({ ...prev, item_cumplimiento: { ...prev.item_cumplimiento, comentario: commentToSave } }));
                            break;
                        case enum__NOTIFICATION_CLASS.CO_TO_VALIDATE:
                            setObjAchieveValidation(prev => ({ ...prev, item_cumplimiento: { ...prev.item_cumplimiento, comentarioValidacion: commentToSave } }));
                            break;
                        default:
                            break;
                    }

                    setNotificationCompleted(inputParam_NotificationTask.id, achieve).then((responseCompleted) => {
                        if (responseCompleted.data.succeeded) {
                            if (inputParam_NeedUpdateNotificationPageList) {
                                notificationTaskDataList.map(item => { if (item.id === inputParam_NotificationTask.id) { item.completed = true; } })
                                notificationTaskDataListFiltred.map(item => { if (item.id === inputParam_NotificationTask.id) { item.completed = true; } })
            
                                notificationTaskMenuData.map(itemMenu => {
                                    if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.UNFULFILLED) { itemMenu.item2 = itemMenu.item2 -1; }
                                    if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.COMPLETED) { itemMenu.item2 = itemMenu.item2 +1; }
                                })
            
                                dispatch(action_setNotificacionTaskMenuItems(notificationTaskMenuData));   
                                dispatch(action_setNotificacionTaskList(notificationTaskDataList));
                                dispatch(action_setNotificacionTaskListFiltred(notificationTaskDataListFiltred));
                                
                                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                            }
                            else {
                                if (!inputParam_SkipActionListUpdate) {
                                    alertList.map(item => { if (item.id === inputParam_NotificationTask.id) { item.completed = true; } })
                                    dispatch(action_updateAlertList(alertList));
                                    dispatch(action_updateEdPPrepareForceGetHeader(true));
                                }

                                try {
                                    if (!isNullUndefined(inputParam_ExternalEventAfterSave)) {
                                        inputParam_ExternalEventAfterSave && inputParam_ExternalEventAfterSave();
                                        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false);
                                    }  
                                } catch (error) {
                                    console.log('Error al actualizar achieves.')
                                }

                                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                            }
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        }
                    }).catch(() => {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    });
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch((error) => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, getSaveCommentErrorMessage(error))
            });
        }
        else {
            if (inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE) {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-neddcommentordocument'))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-neddcomment'))
            }
        }
    };

    const handleGoToPageClick = () => {
        window.open(inputParam_NotificationTask.url, "_blank");
    };

    const handleSetAchivementCommentToSave = (notificationClass, objControlComment) => {
        switch (notificationClass) {
            case enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE:
                setAchievemtComment(objControlComment.currentTarget.value)
                break;
            case enum__NOTIFICATION_CLASS.CO_TO_VALIDATE:
                setValidationComment(objControlComment.currentTarget.value)
                break;
            default:
                break;
        }

        if (isNullUndefinedOrEmpty(objControlComment.currentTarget.value)) {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
        }
        else{
            showMessage(setMessageConfig, false, __MessageTypes.WARNING, '')
        }
    };

    const setterObjCommentDocumentId = (notificationClass, documentId, documentName) => {
        switch (notificationClass) {
            case enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE:
                setObjAchieveValidation(prev => ({ ...prev, item_cumplimiento: { ...prev.item_cumplimiento, documentoCumplimientoId: documentId, documentoCumplimientoNombre: documentName } }));
                break;
            case enum__NOTIFICATION_CLASS.CO_TO_VALIDATE:
                setObjAchieveValidation(prev => ({ ...prev, item_cumplimiento: { ...prev.item_cumplimiento, documentoValidacionId: documentId, documentoValidacionNombre: documentName } }));
                break;
            default:
                break;
        }
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox 
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            objAchieveValidation && inputParam_NotificationTask.canAchieve &&
                            <>
                                {
                                    (inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE ? (objAchieveValidation.item_cumplimiento.puedeCumplir === true) : objAchieveValidation.item_cumplimiento.puedeValidar === true ) && (isNullUndefined(inputParam_NotificationTask.completed)) &&
                                    <PrimaryButton onClick={ () => handleSaveButtonClick(true) } styles={_global_buttonStyles}>{ inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE ? t('data-lang-btn-achieve') : t('data-lang-btn-validate') }</PrimaryButton>                        
                                }
                                {
                                    objAchieveValidation.item_cumplimiento.puedeValidar === true && ((isNullUndefined(inputParam_NotificationTask.completed)) && inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE) &&
                                    <PrimaryButton onClick={ () => handleSaveButtonClick(false) } styles={_global_buttonStyles}>{ t('data-lang-btn-notachieve') }</PrimaryButton>                        
                                }
                            </>
                        }
                        <PrimaryButton onClick={ handleGoToPageClick } className='d-none' styles={_global_buttonStyles}>{ t('data-lang-btn-gotopage') }</PrimaryButton>                        
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={t('data-lang-boxname-aditionalinfo')}
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ "644px" }
                type={PanelType.customNear}
            >
                <Row>              
                    <Col className='p-0 m-0'>              
                        <NotificationTasksCard
                            inputParam_ShowMinimized={true}
                            inputParam_ObjItem={inputParam_NotificationTask}
                            inputParam_HandlerOnClickNotificationTaskRow={null}
                            inputParam_FieldActionHandler={null}
                        /> 
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div name="textarea" rows="4" className='w-100 border' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(inputParam_NotificationTask.description, { USE_PROFILES: { html: true } }) }}></div>
                    </Col>
                </Row>
                <Row>  
                    {
                        objAchieveValidation && objAchieveValidation.item_cumplimiento &&
                        <Col>
                        {
                            (inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE || inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE) &&
                            <Row className='card py-3 my-3' style={{borderColor: (inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE && isValidForm === false ? "red" : "unset")}}>
                                <Col xl={12}><h5>{t('data-lang-boxname-fulfillment')}</h5></Col>
                                {
                                    objAchieveValidation.item_cumplimiento.estadoCumplimientoId === 1 &&
                                    <Col xl={12}>
                                        <Row className="py-0 mt-3">
                                            <Col xl={4}>{t('data-lang-lbl-achieveby')}</Col>
                                            <Col xl={8}>
                                                { `${objAchieveValidation.item_cumplimiento.fullUsuarioDeclaraCumplimiento} - ${moment(objAchieveValidation.item_cumplimiento.fechaCumplimiento).format('DD/MM/YYYY')}` }      
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xl={12}>
                                    <Row className="py-0 mt-2">
                                        <Col xl={4}>{t('data-lang-lbl-comment')}</Col>
                                        <Col xl={8}>
                                            <CTextAreaSimple
                                                showLabel={false}
                                                controlValue={achievemtComment}
                                                setterControlValue={(value) => handleSetAchivementCommentToSave(enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE, value)}
                                                editMode={inputParam_NotificationTask.canAchieve ? ((inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE || inputParam_NotificationTask.completed === true) ? false : (objAchieveValidation.item_cumplimiento.puedeCumplir)) : false}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xl={12} className='col-auto me-auto'>
                                    <NotificationTaskDocumentBox
                                        inputParam_ObjAchieveValidationId={objAchieveValidation.item_cumplimiento.id}
                                        inputParam_ObjDocument={!isNullUndefined(objAchieveValidation) ? {documentId: objAchieveValidation.item_cumplimiento.documentoCumplimientoId, name: objAchieveValidation.item_cumplimiento.documentoCumplimientoNombre} : null}
                                        inputParam_SetObjDocument={(documentId, documentName) => setterObjCommentDocumentId(enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE, documentId, documentName)}
                                        inputParam_SetMessageConfig={setMessageConfig}
                                        inputParam_DocumentAddApiUrl={'obligacioncumplimiento/cumplimiento/document/add'}
                                        inputParam_ParentRowClassNames={"py-0 mt-2"}
                                        inputParam_EditMode={inputParam_NotificationTask.canAchieve ? ((inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE || inputParam_NotificationTask.completed === true) ? false : (objAchieveValidation.item_cumplimiento.puedeCumplir)): false}
                                    />
                                </Col>
                            </Row>
                        }
                        {
                            (inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE || (inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE && inputParam_NotificationTask.iteration !== null)) &&   
                            <Row className='card py-3 my-3' style={{borderColor: (inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE && isValidForm === false ? "red" : "unset")}}>
                                <Col xl={12}><h5>{t('data-lang-boxname-validation')}</h5></Col>
                                {
                                    objAchieveValidation.item_cumplimiento.estadoValidacionId === 1 &&
                                    <Col xl={12}>
                                        <Row className="py-0 mt-3">
                                            <Col xl={4}>{t('data-lang-lbl-validatedby')}</Col>
                                            <Col xl={8}>
                                                { `${objAchieveValidation.item_cumplimiento.fullUsuarioDeclaraValidacion} - ${moment(objAchieveValidation.item_cumplimiento.fechaValidacion).format('DD/MM/YYYY')}` }      
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col xl={12}>
                                    <Row className="py-0 mt-2">
                                        <Col xl={4}>{t('data-lang-lbl-comment')}</Col>
                                        <Col xl={8}>
                                            <CTextAreaSimple
                                                showLabel={false}
                                                controlValue={validationComment}
                                                setterControlValue={(value) => handleSetAchivementCommentToSave(enum__NOTIFICATION_CLASS.CO_TO_VALIDATE, value)}
                                                editMode={inputParam_NotificationTask.canAchieve ? (inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE && inputParam_NotificationTask.completed === null ? (objAchieveValidation.item_cumplimiento.puedeValidar) : false):false}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xl={12}>
                                    <NotificationTaskDocumentBox
                                        inputParam_ObjAchieveValidationId={objAchieveValidation.item_cumplimiento.id}
                                        inputParam_ObjDocument={!isNullUndefined(objAchieveValidation) ? {documentId: objAchieveValidation.item_cumplimiento.documentoValidacionId, name: objAchieveValidation.item_cumplimiento.documentoValidacionNombre} : null}
                                        inputParam_SetObjDocument={(documentId, documentName) => setterObjCommentDocumentId(enum__NOTIFICATION_CLASS.CO_TO_VALIDATE, documentId, documentName)}
                                        inputParam_SetMessageConfig={setMessageConfig}
                                        inputParam_DocumentAddApiUrl={'obligacioncumplimiento/cumplimiento/validacion/document/add'}
                                        inputParam_ParentRowClassNames={"py-0 mt-2"}
                                        inputParam_EditMode={inputParam_NotificationTask.canAchieve ? (inputParam_NotificationTask.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE && inputParam_NotificationTask.completed === null ? true : false): false}

                                    />
                                </Col>
                            </Row>
                        }
                        </Col>
                    }
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelAchieveValidateNotification.propTypes = {
    inputParam_NotificationTask: PropTypes.object.isRequired,  
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,  
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,      
};

export default SidePanelAchieveValidateNotification;